import { render, staticRenderFns } from "./td-Createtime.vue?vue&type=template&id=9cb4fab0&"
import script from "./td-Createtime.vue?vue&type=script&lang=js&"
export * from "./td-Createtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports